import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const DashboardService = {
    getResumen: async (idEmpresa) => {
        return await getAxios().get(`/api/dashboard/resumen`, {
            params: { idEmpresa }
        });
    }
};
